import { render, staticRenderFns } from "./SelectCommodityModal.vue?vue&type=template&id=6b212d21&scoped=true"
import script from "./SelectCommodityModal.vue?vue&type=script&lang=js"
export * from "./SelectCommodityModal.vue?vue&type=script&lang=js"
import style0 from "./SelectCommodityModal.vue?vue&type=style&index=0&id=6b212d21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b212d21",
  null
  
)

export default component.exports